module.exports = __webpack_public_path__ + "static/img/image20.7c18bc1b.png";